module.exports = __webpack_public_path__ + "img/articleBottomOverlay.867c835f.png";